<template>
    <div class="amazon-certification-page">

        <el-tabs v-model="tableType" @tab-click="handleSelectChange">
            <el-tab-pane label="题库" name="tk"></el-tab-pane>
            <el-tab-pane label="真实问答" name="zswd"></el-tab-pane>
        </el-tabs>
        <!-- 查询区域 -->
        <div class="select-box">
            <div class="select-item">
                <div class="select-label">编号</div>
                <el-select v-model="searchForm.personNo" @change="handleSelectChange">
                    <el-option v-for="item in personNoList" :label="item.personNo" :value="item.id" :key="item.id"></el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="handleSearch">
                查询
            </el-button>

            <el-button @click="handleReset">
                重置
            </el-button>

            <el-button type="primary" @click="handleImportQuestion">
                导入题库
            </el-button>

            <el-button type="primary" @click="handleImportQa">
                导入真实问答
            </el-button>
        </div>


        <el-table v-loading="listLoading" v-if="tableType == 'tk'" :data="list" border fit highlight-current-row style="width: 100%" height="720">
            <el-table-column label="编号" prop="personNo" width="100" align="center" />
            <el-table-column label="分类" prop="category" width="180" />
            <el-table-column label="问题" prop="question" min-width="300" />
            <el-table-column label="参考答案" prop="referenceAnswer" min-width="300" />
            <el-table-column label="顺序" prop="questionOrder" width="80" align="center" />
            <el-table-column label="是否通过" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.passed === 1 ? 'success' : 'info'">
                        {{ scope.row.passed === 1 ? '已通过' : '未通过' }}
                    </el-tag>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="importType === 'question' ? '导入题库' : '导入真实问答'" :visible.sync="personDialogVisible"
            width="500px" :close-on-click-modal="false" @closed="resetPersonDialog">
            <el-form ref="personForm" :model="personForm" label-width="100px">
                <el-form-item label="人员编号">
                    <el-input v-model="personForm.personNo" placeholder="请输入 person_no" maxlength="50" clearable />
                </el-form-item>

                <el-form-item label="Excel文件">
                    <el-upload ref="upload" action="" :auto-upload="false" :show-file-list="true" :limit="1"
                        accept=".xlsx,.xls" :on-change="handleFileChange" :on-remove="handleFileRemove"
                        :before-upload="beforeFileUpload">
                        <el-button type="primary" icon="el-icon-upload2">
                            选择Excel文件
                        </el-button>

                        <div slot="tip" class="el-upload__tip">
                            只能上传 xls、xlsx 文件
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button @click="personDialogVisible = false">
                    取消
                </el-button>

                <el-button type="primary" :loading="importLoading" @click="confirmImport">
                    导入
                </el-button>
            </span>
        </el-dialog>

        <!-- ============================== -->
        <!-- 真实问答 -->
        <!-- ============================== -->

        <el-dialog title="真实认证问答记录" :visible.sync="qaDialogVisible" width="900px" :close-on-click-modal="false">

            <div v-if="currentQaList.length > 0" class="qa-list">

                <div v-for="item in currentQaList" :key="item.id" class="qa-item">

                    <div class="qa-order">
                        第 {{ item.questionOrder }} 问
                    </div>

                    <div class="qa-question">

                        <span class="qa-label">
                            问：
                        </span>

                        {{ item.question }}

                    </div>

                    <div class="qa-answer">

                        <span class="qa-label">
                            答：
                        </span>

                        {{ item.answer || '暂无回答' }}

                    </div>

                </div>

            </div>

            <el-empty v-else description="暂无真实问答记录" />

            <span slot="footer">

                <el-button @click="qaDialogVisible = false">
                    关闭
                </el-button>

            </span>

        </el-dialog>

    </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import { ajaxPost, Baseurl } from "@/api/api/api";
import { ajaxGet } from '../../api/api/api';

export default {
    name: 'AmazonCertificationQuestion',
    data() {
        return {
            searchForm: {
                personNo: ''
            },

            currentPersonNo: '',

            questionList: [],

            currentPassed: false,

            loading: false,

            statusLoading: false,

            // ==========================
            // Excel
            // ==========================

            importLoading: false,

            // ==========================
            // 真实问答
            // ==========================

            qaDialogVisible: false,

            currentQaList: [],
            listLoading: false,

            list: [],

            listQuery: {
                personNo: ''
            },

            personDialogVisible: false,

            importType: '',

            personForm: {
                personNo: '',
                file: null
            },
            personNoList: [],
            tableType: 'tk', //tk：题库，zswd：真实问答
        }

    },
    created(){
        this.getCertificationList();
    },

    methods: {
        getCertificationList(){
            ajaxGet(Baseurl + "amazonCertificationController/getCertificationList").then((res) => {
                if(res.data.code == 200){
                    this.personNoList = res.data.data;
                }
                if(this.personNoList.length == 0){
                    this.$message.warning("暂无数据请添加")
                }
            })
        },
        handleSelectChange(){
            let url = '';
            if(this.tableType == 'tk'){
                url = Baseurl + "amazonCertificationController/getDetail"
            }else{
                url = Baseurl + "amazonCertificationController/getDetail"
            }
            this.list = [];
            ajaxGet(url + "?personNo=" + this.searchForm.personNo).then((res) => {
                if(res.data.code == 200){
                    this.list = res.data.data;
                }
            })
        },
        handleFileChange(file, fileList) {
            this.personForm.file = file.raw
        },

        handleFileRemove() {
            this.personForm.file = null
        },

        confirmImport() {
            if (!this.personForm.personNo ||
                !this.personForm.personNo.trim()) {
                this.$message.warning('请输入人员编号')
                return
            }

            if (!this.personForm.file) {
                this.$message.warning('请选择Excel文件')
                return
            }

            const personNo = this.personForm.personNo.trim()
            const file = this.personForm.file

            this.parseExcel(file, (rows) => {
                if (this.importType === 'question') {
                    this.parseQuestionExcel(personNo, rows)
                } else {
                    this.parseQaExcel(personNo, rows)
                }
            })
        },
        resetPersonDialog() {
            this.personForm.personNo = ''
            this.personForm.file = null
            this.importType = ''

            if (this.$refs.upload) {
                this.$refs.upload.clearFiles()
            }
        },
        parseQuestionExcel(personNo, rows) {
            const list = []
            let currentCategory = ''
            let questionOrder = 1

            for (let i = 0; i < rows.length; i++) {
                const row = rows[i]

                const question = row[0]
                    ? String(row[0]).trim()
                    : ''

                const answer = row[1]
                    ? String(row[1]).trim()
                    : ''

                // 两列都为空，停止
                if (!question && !answer) {
                    break
                }

                // 第一列有值，第二列没有值 = 分类
                if (question && !answer) {
                    currentCategory = question
                    continue
                }

                // 正常问题
                if (question) {
                    list.push({
                        personNo: personNo,
                        category: currentCategory,
                        question: question,
                        referenceAnswer: answer,
                        questionOrder: questionOrder++
                    })
                }
            }

            if (!list.length) {
                this.$message.warning('Excel中没有有效的题库数据')
                return
            }

            this.submitQuestionImport(personNo, list)
        },
        parseQaExcel(personNo, rows) {
            const list = []
            let questionOrder = 1

            for (let i = 0; i < rows.length; i++) {
                const row = rows[i]

                const question = row[0]
                    ? String(row[0]).trim()
                    : ''

                const answer = row[1]
                    ? String(row[1]).trim()
                    : ''

                // 两列都为空，停止
                if (!question && !answer) {
                    break
                }

                if (!question) {
                    continue
                }

                list.push({
                    personNo: personNo,
                    question: question,
                    answer: answer,
                    questionOrder: questionOrder++
                })
            }

            if (!list.length) {
                this.$message.warning('Excel中没有有效的真实问答数据')
                return
            }

            this.submitQaImport(personNo, list)
        },
        parseExcel(file, callback) {
            const reader = new FileReader()

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result)

                    const workbook = XLSX.read(data, {
                        type: 'array'
                    })

                    const sheetName = workbook.SheetNames[0]
                    const worksheet = workbook.Sheets[sheetName]

                    const rows = XLSX.utils.sheet_to_json(
                        worksheet,
                        {
                            header: 1,
                            defval: ''
                        }
                    )

                    callback(rows)
                } catch (e) {
                    console.error(e)
                    this.$message.error('Excel解析失败')
                }
            }

            reader.readAsArrayBuffer(file)
        },
        submitQuestionImport(personNo, list) {
            this.importLoading = true

            ajaxPost(
                Baseurl + 'amazonCertificationController/importQuestion',
                {
                    personNo: personNo,
                    list: list
                }
            ).then(res => {
                if (res.data.code === 200) {
                    this.$message.success('题库导入成功')
                    this.personDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(
                        res.data.message || '题库导入失败'
                    )
                }
            }).catch(() => {
                this.$message.error('题库导入失败')
            }).finally(() => {
                this.importLoading = false
            })
        },
        submitQaImport(personNo, list) {
            this.importLoading = true

            ajaxPost(
                '/api/admin/amazon/qa/import',
                {
                    personNo: personNo,
                    list: list
                }
            ).then(res => {
                if (res.data.code === 200) {
                    this.$message.success('真实问答导入成功')
                    this.personDialogVisible = false
                } else {
                    this.$message.error(
                        res.data.message || '真实问答导入失败'
                    )
                }
            }).catch(() => {
                this.$message.error('真实问答导入失败')
            }).finally(() => {
                this.importLoading = false
            })
        },
        getList(){

        },
        beforeFileUpload(file) {
            const isExcel =
                file.name.endsWith('.xls') ||
                file.name.endsWith('.xlsx')

            if (!isExcel) {
                this.$message.error('只能上传xls或xlsx文件')
                return false
            }

            return true
        },
        handleImportQuestion() {
            this.importType = 'question'
            this.personDialogVisible = true
        },

        handleImportQa() {
            this.importType = 'qa'
            this.personDialogVisible = true
        },
        async handleSearch() {
            if (!this.searchForm.personNo) {
                this.$message.warning(
                    '请输入人员编号'
                )
                return
            }
            this.loading = true
            try {
                const res = await axios.get(
                    '/api/admin/amazon/certification/detail',
                    {
                        params: {
                            personNo:
                                this.searchForm.personNo
                        }
                    }
                )
                if (
                    res.data &&
                    res.data.code === 200
                ) {

                    const data =
                        res.data.data || {}

                    this.currentPersonNo =
                        this.searchForm.personNo

                    this.questionList =
                        data.questionList || []

                    this.currentPassed =
                        data.passed === true ||
                        data.passed === 1

                } else {

                    this.$message.error(
                        res.data.message ||
                        '查询失败'
                    )

                    this.clearResult()

                }

            } catch (e) {

                console.error(e)

                this.$message.error(
                    '查询失败，请检查网络或服务器'
                )

                this.clearResult()

            } finally {

                this.loading = false

            }

        },

        // =====================================================
        // 重置
        // =====================================================

        handleReset() {

            this.searchForm.personNo = ''

            this.clearResult()

        },

        clearResult() {

            this.currentPersonNo = ''

            this.questionList = []

            this.currentPassed = false

            this.currentQaList = []

        },

    }
}
</script>

<style scoped lang="scss">
.amazon-certification-page {
    .select-box {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 10px;

        .select-item {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .select-label {
                margin-right: 10px;
            }
        }

        .el-button {
            margin: 0;
            margin-right: 10px;
        }

    }
}

.search-card,
.info-card,
.table-card {
    margin-bottom: 15px;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 600;
}

.header-tip {
    color: #909399;
    font-size: 13px;
    font-weight: normal;
}

.person-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.info-item {
    display: flex;
    align-items: center;
    margin-right: 40px;
    margin-bottom: 5px;
}

.info-label {
    color: #909399;
    margin-right: 8px;
}

.info-value {
    color: #303133;
    font-weight: 600;
}

.status-action {
    margin-left: auto;
    margin-right: 0;
}

.qa-list {
    max-height: 600px;
    overflow-y: auto;
}

.qa-item {
    padding: 18px 20px;
    margin-bottom: 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
}

.qa-order {
    margin-bottom: 12px;
    color: #409eff;
    font-size: 14px;
    font-weight: 600;
}

.qa-question,
.qa-answer {
    line-height: 1.8;
    font-size: 14px;
}

.qa-answer {
    margin-top: 8px;
    color: #606266;
}

.qa-label {
    display: inline-block;
    width: 35px;
    color: #303133;
    font-weight: 600;
}

/*
 * Element UI 的 el-upload
 * 默认是块级元素，这里让它和按钮保持在同一行
 */
.search-card .el-upload {
    display: inline-block;
}
</style>